import './styles.css'; 
import { DateRangePicker } from 'rsuite';
import { useState, useEffect } from 'react';  
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";

export default function DateHeader(props) {  
  let today_start = new Date();
  today_start.setHours(0, 0, 0, 0);
  let today_end = new Date(); 
  today_end.setHours(23, 59, 59, 59);  
  let yesterday_start = new Date();
  yesterday_start.setDate(yesterday_start.getDate() - 1);
  yesterday_start.setHours(0, 0, 0, 0);
  let yesterday_end = new Date();
  yesterday_end.setDate(yesterday_end.getDate() - 1);
  yesterday_end.setHours(23, 59, 59, 59); 
  let last_7_days = new Date();
  last_7_days.setDate(today_end.getDate() - 6); 
  last_7_days.setHours(0, 0, 0, 0);  
  let last_15_minutes = new Date();
  last_15_minutes.setMinutes(last_15_minutes.getMinutes() - 15);
  let last_30_minutes = new Date();
  last_30_minutes.setMinutes(last_30_minutes.getMinutes() - 30);
  let last_24_hours = new Date();
  last_24_hours.setHours(last_24_hours.getHours() - 24);
  let last_1_hour = new Date();
  last_1_hour.setHours(last_1_hour.getHours() - 1);
  let last_3_hour = new Date();
  last_3_hour.setHours(last_3_hour.getHours() - 3);

  const predefinedRanges = [ 
    {
      label: "Last 15 minutes",
      value: [last_15_minutes, new Date()],
      placement: "left",
    },  
    {
      label: "Last 30 minutes",
      value: [last_30_minutes, new Date()],
      placement: "left",
    },    
    {
      label: "Last 1 hour",
      value: [last_1_hour, new Date()],
      placement: "left",
    },  
    {
      label: "Last 3 hours",
      value: [last_3_hour, new Date()],
      placement: "left",
    },   
    {
      label: "Last 24 hours",
      value: [last_24_hours, new Date()],
      placement: "left",
    },   
    {
      label: "Last 3 days",
      value: [subDays(new Date(), 2), new Date()],
      placement: "left",
    },  
    {
      label: "Last 7 days",
      value: [subDays(new Date(), 6), new Date()],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
    {
      label: "Last 90 days",
      value: [subDays(new Date(), 89), new Date()],
      placement: "left",
    },   
    {
      label: "Last year",
      value: [
        new Date(new Date().getFullYear() - 1, 0, 1),
        new Date(new Date().getFullYear(), 0, 0),
      ],
      placement: "left",
    }, 
    {
      label: "Today", 
      value: (value) => { 
        return [today_start, today_end];
      },
      appearance: "default",
    },  
    {
      label: "Yesterday", 
      value: (value) => { 
        return [yesterday_start, yesterday_end];
      },
      appearance: "default",
    },    
    {
      label: "This week", 
      value: (value) => { 
        return [startOfWeek(new Date()), endOfWeek(new Date())];
      },
      appearance: "default",
    },    
    {
      label: "Last week", 
      value: (value) => {
        const [start = new Date()] = value || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
  ];
  
  /** DateRangePicker from rsuite **/
  const [value, setValue] = useState([last_7_days, today_end]);  
  const handleChange = (value) => {  
    setValue(value);
    if (value !== null) {
      let gte = value[0];
      let lte = value[1]; 
      props.callback({gte: Date.parse(gte), lte: Date.parse(lte)}); 
    } else { 
      setValue([last_7_days, today_end]) 
      props.callback({gte: Date.parse(last_7_days), lte: Date.parse(today_end)}); 
    }
  }
  
  const handleClean = () => {
    setValue([last_7_days, today_end]) 
  } 
  
  
  useEffect(() => {
    if (window.sessionStorage.getItem("dateRange")) {
      const gte = parseInt(window.sessionStorage.getItem("dateRange").split(",")[0]);
      const lte = parseInt(window.sessionStorage.getItem("dateRange").split(",")[1])
      setValue([
        new Date(gte), 
        new Date(lte)
      ]); 
      props.callback({gte: gte, lte: lte}); 
    }   
  }, [])
  
  useEffect(() => { 
    if (props.value) {
      const current = props.value;
      var three_hours_later = new Date(props.value);
      three_hours_later.setHours(three_hours_later.getHours() + 3); 
      setValue([current, three_hours_later]); 
      props.callback({gte: Date.parse(current), lte: Date.parse(three_hours_later)});
    }
  }, [props.value]) 
   
  return ( 
    <DateRangePicker value={value} onClean={handleClean} format="dd MMM yyyy hh:mm aa" ranges={predefinedRanges} defaultValue={value} showMeridiem onChange={handleChange}/>
  );
} 